import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-parameterized-search',
  templateUrl: './parameterized-search.component.html',
  styleUrls: ['./parameterized-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class ParameterizedSearchComponent {
  @Input() inputName: string;
  @Input() inputPlaceholder?: string;
  @Input() selectName: string;
  @Input() searchParameters: { id: string; label: string }[];
}
